<template>
<div class='fm'>
  <div class="fs">
    <div class="sh">
      Sign in to continue
    </div>
    <div>
      <span>
        <button class="btn btn-warning subBtn" @click="signIn">Sign In</button>
      </span>
    </div>
  </div>
</div>
</template>

<style>
.fm {
  width: 100%;
}
.fs {
  position: relative;
  margin-top: 100px;
  margin-bottom: 20px;
  background-color: var(--form-color);
  padding: 35px 40px;
  text-align: left;
  display: inline-block;
  border-radius: 6px;
  -webkit-box-shadow: 1px 1px 4px 0 rgba(0,0,0,.15);
  box-shadow: 1px 1px 4px 0 rgba(0,0,0,.15);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.sh {
  color: var(--deepSquidInk);
  margin-bottom: 24px;
  font-size: 18px;
  font-weight: 500;
}

.subBtn {
  min-width: 153px;
  color: white;
}
</style>

<script>

import awsexports from '../aws-exports';
import awsauth from '../awsauth';

export default {
  name: 'CognitoSignIn',
  data () {
    return {}
  },
  computed: {
    signInUrl() {
      return `https://${awsauth.domain}/login?client_id=${awsexports.aws_user_pools_web_client_id}&response_type=${awsauth.responseType}&scope=${awsauth.scope.join('+')}&redirect_uri=${awsauth.redirectSignIn}`;
    }
  },
  methods: {
    signIn: function() {
      window.location = this.signInUrl;
    },
  }
}
</script>
